// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';

// utilities
import _, {merge, get} from 'lodash';
import moment from 'moment';
import cx from 'classnames';

// components
import Modal from '../../../../../common/components/r_Modal';
import CloseX from '../../../../../common/svgs/CloseX';
import FlagIcon from '../../../../../common/svgs/FlagIcon';
import CheckList from '../../../../../common/components/c_CheckList';
import StatusDropDown from '../../../../../common/components/StatusDropDown';

import {lookup, getLookupValue} from '../../../../../redux/helpers/staticData';
import * as companyApi from '../../../../../redux/actionCreators/async/companies';
import * as contactApi from '../../../../../redux/actionCreators/async/contacts';
import * as contactStore from '../../../../../redux/actionCreators/sync/contacts';
import {findContact} from '../../../../../redux/helpers/contacts';

import prettyPhone from '../../../../../lib/prettyPhone';

@connect((store, props) => {
  const contactId = parseInt(props.params.contactId, 10) || 0;
  const contact = findContact({profile: {id: contactId}}, get(store.admin.contacts, 'items', []));

  return {
    staticData: store.staticData,
    contact,
    route: {
      params: props.params,
      query: props.location.query
    } // actually being from from react-redux-router to regular props
  };
})
export default class ExpandedCard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    contact: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    route: PropTypes.object,
    location: PropTypes.object,
    query: PropTypes.object,
    params: PropTypes.object, // comes from react-redux-router
  }

  constructor(props, context) {
    super(props, context);

    const initialState = {
      clientAdvisors: this.props.staticData.clientAdvisers,
      relationshipManagers : this.props.staticData.relationshipManagers,
      expandedStyle: {
        height: 300,
        'min-width': 720,
        width: '70%'
      },
      tags: _.get(this.props.contact, 'profile.tags', [])
    };

    this.state = initialState;
  }


  onClose = (event, currentStatusGroup) => {
    this.props.dispatch(goBack());
  };

  handleStatusChange = (contactId, companyId) => (event, value) => {
    if (value) {
      this.props.dispatch(companyApi.updateCompanyStatus(companyId, value, (err, result) => {
        if (err || !result) {
          return console.error(err || 'Update failed.');
        }

        // refresh contact
        this.props.dispatch(contactApi.getContact(contactId, (err, data) => {
          if (err || !data) {
            return console.error(err || 'Fetch failed.');
          }
          this.props.dispatch(contactStore.updateContact(data));
        }));
      }));
    }
  }

  handleTagChange = (contactId) => (event, value) => {
    let doAdd = true;
    let tagId = -1;
    const currentTags = this.props.contact.profile.tags || [];
    const addedTags = _.difference(value, currentTags);

    if (addedTags.length) {
      tagId = addedTags[0];
    }
    else {
      const removedTags = _.difference(currentTags, value);
      tagId = removedTags[0];
      doAdd = false;
    }

    const tagRequest = {contactId: contactId, tagId: tagId}
    const tagCallback = (err, result) => {
      if (err) {
        return console.error(err || 'Update failed.');
      }

      let updatedContact = this.props.contact;
      let updatedTags = updatedContact.profile.tags || [];
      if (doAdd) {
        updatedTags.push(tagId);
      }
      else {
        _.pull(updatedTags, tagId);
      }
      updatedContact.profile.tags = updatedTags;
      const contactData = {contact: updatedContact, group: updatedContact.profile.contactStatusGroup};
      this.props.dispatch(contactStore.updateContact(contactData));
      this.setState({tags: updatedTags});
    }

    const tagAction = doAdd ? contactApi.addTag(contactId, tagRequest, tagCallback) : contactApi.deleteTag(contactId, tagRequest, tagCallback);
    this.props.dispatch(tagAction);
  }

  handleWorksheetClick = (event, profileId) => {
    this.props.dispatch(push(`/admin/contacts/${profileId}/details`));
  };

  handleCompanyClick = (event, companyId) => {
    this.props.dispatch(push(`/admin/companies/${companyId}/details`));
    event.stopPropagation();
  };

  render() {
    const {
      user,
      profile,
      company
    } = this.props.contact || {};

    if (!user) return null;
    const staticData = this.props.staticData;

    const currentStatus = getLookupValue(staticData, 'contactStatus', {id: profile.contactStatus});
    const currentStatusGroup = getLookupValue(staticData, 'contactStatusGroups', (s) => !!~s.statuses.indexOf(profile.contactStatus));

    const sanitize = (val) => val || '';
    const expand = (type, val) => sanitize(lookup(staticData, type, val));
    const formattedAddress = () => `${sanitize(user.city)}, ${expand('stateList', {id: user.state})}, ${sanitize(user.zip)}`;

    const lastUpdated = user ? [user.dateModified, profile.dateModified, user.dateCreated, profile.dateCreated]
                        .filter(d => !!d)
                        .sort((d1, d2) => moment.utc(d2).diff(moment.utc(d1)))
                        .shift() : '';
    const adviser = this.state.clientAdvisors.find((item) => item.employeeId === profile.clientAdvisorId);
    const relationshipMgr = this.state.relationshipManagers.find(item => item.employeeId === company.relationshipManagerId);

    const followUpTask = _(this.props.contact.profile.tasks)
                            .filter(task => task.taskFollowUpDate && !task.closed)
                            .sortBy(task => new Date(task.taskFollowUpDate))
                            .head();

    const contactPhoneType = expand('contactPhoneTypes', {id: user.phoneType1});
    return (
      this.props.contact
      &&
      <Modal
        show fadeModal fadeModalChildren noScroll outsideUnclickable
        onClose={(event) => this.onClose(event, currentStatusGroup.name)}
        transitionDuration={400}
        opacityTransitionIn='cubic-bezier(0,1,.2,.8)'
        modalContentClass={cx('expanded-card-container')}
        className='contact-dashboard-expanded-card'
      >
        <ModalClose/>
            <div className='front-card' data-id={`${user.email} front`} style={this.state.expandedStyle}>
              <div className='main-card'>
                <div className='card-sections'>
                  <div className='name-container'>
                    <div className='full-name' data-id='Full Name'>{`${_.capitalize(user.firstName)} ${_.capitalize(user.middleName)} ${_.capitalize(user.lastName)}`}</div>
                  </div>
                  <div className='contact-col'>
                    <div className='title' data-id='Title'>{profile.title}</div>
                    <div className='department' data-id='Department'>Department: {profile.department}</div>
                    <div className='client-adviser' data-id='Client Adviser'>Client Adviser: {adviser ? `${adviser.firstName} ${adviser.lastName}` : ''}</div>
                    <div className='company' data-id='Company' onClick={(event) => this.handleCompanyClick(event, company.id)}>Company: {company.name}</div>
                    <div className='address' data-id='Address'>{formattedAddress()}</div>
                    <div className='email' data-id='Email'>{user.email}</div>
                  </div>
                </div>
                <div className='card-sections'>

                  <div className='contact-status-container'>
                    <div className='contact-status-section'>
                      <StatusDropDown
                        status={currentStatus}
                        smallDisplay={true}
                        menuItems={this.props.staticData.companyStatus}
                        onChange={this.handleStatusChange(profile.id, company.id)}
                        data-id='status'
                      />
                      <CheckList
                        className={'tag-selector'}
                        data-id={'Tag'}
                        persistentLabel={'Tag'}
                        menuItems={this.props.staticData.contactTags}
                        defaultValue={profile.tags || []}
                        popoverStyle={{width: '300px'}}
                        popoverClassName={'tag-selector-checklist-dropdown'}
                        autoWidth
                        onChange={this.handleTagChange(profile.id)}
                        data-id='tags'
                      />
                    </div>
                  </div>

                  <div className='contact-tags'>
                    {
                      _.map(this.state.tags, (tag) => {
                      return <div className='contact-tag' data-id={`Contact tag ${tag}`}><FlagIcon /> {lookup(this.props.staticData, 'contactTags', {id: tag})}</div>;
                    }).slice(0, 2)

                    }

                    {
                      (this.state.tags || []).length > 2 && <span>...</span>
                    }
                  </div>

                  <div className='contact-col right'>
                    <div>Timezone: {expand('timezoneList', {id: user.timezone})}</div>
                    <div>Date Added: {profile.dateCreated ? moment(profile.dateCreated).format('L') : sanitize(profile.dateCreated)}</div>
                    <div>Follow Up Date: {followUpTask ? moment(followUpTask.taskFollowUpDate).format('L') : sanitize(followUpTask)}</div>

                    <div>
                      {user.phoneNumber1 && user.phoneType1 && `${contactPhoneType}: `}{prettyPhone(user.phoneNumber1)}
                      {contactPhoneType === 'Main' &&
                        <span> Ext: {user.phoneExtension1}</span>
                      }
                    </div>
                  </div>
                </div>

              </div>
            </div>

          <div className='detail-toggle outside-card' data-id='View Worksheet' onClick={(event) => this.handleWorksheetClick(event, profile.id)}>
            View Worksheet
          </div>
      </Modal>
      ||
      <div/>
    );
  }
}


// creating separate component as slight hack needed to allow access to animating "closeModal" function in close button
class ModalClose extends Component {
  static propTypes = {
    closeModal: PropTypes.func,
    removeState: PropTypes.any
  }

  constructor() {
    super();
    this.respondToKeyPress = ::this.respondToKeyPress;
  }

  componentDidMount() {
    window.addEventListener('keydown', this.respondToKeyPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.respondToKeyPress);
  }

  respondToKeyPress(event) {
    // escape key response
    if(event.keyCode === 27 && this.props.closeModal) {
      if(this.props.removeState && !event.shiftKey) {
        return this.props.removeState();
      }

      this.props.closeModal();
    }
  }

  render() {
    return (
      <div className='modal-close outside-card' data-id='Close' onClick={this.props.closeModal}>
        dashboard <CloseX style={{color: '#fff'}}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Dashboard/Card/index.js